import React, { memo, forwardRef } from 'react';
import ChevronRightIcon from '@atlaskit/icon/core/migration/chevron-right';

import EditorBackgroundColorIcon from '@atlaskit/icon/core/migration/paint-bucket--editor-background-color';
import { ButtonItem, type ButtonItemProps } from '@atlaskit/menu';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { useSoftwareProjectTheming } from '@atlassian/jira-project-theme-providers/src/controllers/software-theme/index.tsx';
import messages from './messages.tsx';

export type ThemePickerButtonItemProps = Pick<ButtonItemProps, 'onClick' | 'isSelected' | 'testId'>;

export const ThemePickerButtonItem = memo(
	forwardRef<HTMLElement, ThemePickerButtonItemProps>(
		({ onClick, isSelected, testId, ...props }, ref) => {
			const { formatMessage } = useIntl();

			const { hasSoftwareTheming } = fg('jira-theming-discoverability')
				? // eslint-disable-next-line react-hooks/react-compiler
					// eslint-disable-next-line react-hooks/rules-of-hooks
					useSoftwareProjectTheming()
				: { hasSoftwareTheming: false };

			return (
				<ButtonItem
					iconBefore={
						<EditorBackgroundColorIcon label="" LEGACY_size="medium" spacing="spacious" />
					}
					iconAfter={
						<ChevronRightIcon label="" LEGACY_size="medium" spacing="spacious" size="small" />
					}
					onClick={onClick}
					testId={testId}
					isSelected={isSelected}
					ref={ref}
					{...props}
				>
					{formatMessage(messages.setProjectBackgroundMenuItem)}
					{hasSoftwareTheming && !fg('remove_software_theming_new_lozenge') && (
						<>
							{' '}
							<Lozenge appearance="new">{formatMessage(messages.newLozengeLabel)}</Lozenge>
						</>
					)}
				</ButtonItem>
			);
		},
	),
);
